import $ from "jquery";

try {
    // Check for support of the actual selector
    document.querySelector(":focus-within");

    // We support the focus-within selector, so don't need the polyfill
    window.DISABLE_FOCUS_WITHIN = true;
} catch (e) {
    // We don't support focus-within
}

let running;
let last;

function scheduleUpdate() {
    // We only want to update at most once per frame
    if (running || window.DISABLE_FOCUS_WITHIN) {
        return;
    }

    running = true;
    requestAnimationFrame(() => {
        let element = document.activeElement;

        running = false;
        // We only want to update the focus-within classes when our focus has changed
        if (last === element) {
            return;
        }

        last = element;

        // Remove the focus within class from all elements on the page
        $(".focus-within").removeClass("focus-within");

        // Add the class to the focused element and all parents
        $(element).parents().add(element).addClass("focus-within");
    });
}

if ('undefined' === typeof window.DISABLE_FOCUS_WITHIN || window.DISABLE_FOCUS_WITHIN === false) {
    document.addEventListener("focus", scheduleUpdate, true);
    document.addEventListener("blur", scheduleUpdate, true);

    setTimeout(scheduleUpdate);
}
